/* api.js */
import axios from "axios";
axios.defaults.headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Headers": "*",
};
//axios.defaults.maxContentLength = 2000; // 限制傳送大小
// 請求時間超過 1000毫秒(1秒)，請求會被中止
//axios.defaults.timeout = 300000;
// 選項: 'arraybuffer', 'document', 'json', 'text', 'stream'
// 瀏覽器才有 'blob' ， 預設為 'json'
axios.defaults.responseType = "json"; // 伺服器回應的數據類型
// 伺服器回應的編碼模式 預設 'utf8'
axios.defaults.responseEncoding = "utf8";
// 用來判斷是否為 跨域存取 (cross-site Access-Control requests)
// 等同 Access-Control-Allow-Credentials 表頭
// 用來解決 CORS
axios.defaults.withCredentials = true;

const api = {
  get: (url, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: params,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  Download: (url, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: params,
          responseType: 'blob',
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  post: (url, params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            // 请求已发出，但服务器响应的状态码不在 2xx 范围内
           // console.log(error.response.data);
           // console.log(error.response.status);
           // console.log(error.response.headers);
          } else {
            // Something happened in setting up the request that triggered an Error
           // console.log("Error", error.message);
          }
          //console.log(error.config);
        });
    });
  },

  put: (url, params) => {
    return new Promise((resolve, reject) => {
      axios
        .put(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            // 请求已发出，但服务器响应的状态码不在 2xx 范围内
            //console.log(error.response.data);
            //console.log(error.response.status);
            //console.log(error.response.headers);
          } else {
            // Something happened in setting up the request that triggered an Error
           // console.log("Error", error.message);
          }
         // console.log(error.config);
        });
    });
  },

  delete: (url, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "delete",
        url: url,
        data: params,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            // 请求已发出，但服务器响应的状态码不在 2xx 范围内
            //console.log(error.response.data);
            //console.log(error.response.status);
            //console.log(error.response.headers);
          } else {
            // Something happened in setting up the request that triggered an Error
            //console.log("Error", error.message);
          }
          //console.log(error.config);
        });
    });
  },
};

export default api;
